import {useStore} from '@/store/root-store';
import styles from '../../style.module.scss';
import {observer} from 'mobx-react';
import {Unsplash} from './Unsplash';
import styled from 'styled-components';
import {Radio, RadioChangeEvent} from 'antd';

interface Props {
  onChange: (editorState: any) => any;
}

export const FreeStockTab = observer(({onChange}: Props) => {
  const {contentOptimizer: {currentPage}} = useStore('');
  const {contentType, setContentType} = currentPage;

  const onContentTypeChange = (e: RadioChangeEvent) => {
    setContentType(e.target.value);
  };

  return (
    <>
      <div className={styles.contentIdeasDrawerContent}>
        <div className={styles.contentIdeasTitle}>
          Add Image
        </div>
        <p style={{marginTop: 10, color: '#4E5156'}}> Click on the image to add it to editor.</p>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
        Content type:
          <Radio.Group onChange={onContentTypeChange} value={contentType}>
            <RadioStyled value={'toArticle'}>To Article</RadioStyled>
            <RadioStyled value={'asHero'}>As Hero</RadioStyled>
          </Radio.Group>
        </div>
        <Unsplash contentType={contentType} store={currentPage} onChange={onChange}/>

      </div>
    </>
  );
});

const RadioStyled = styled(Radio)`
    .ant-radio-checked .ant-radio-inner {
      background-color: #7f4ead !important;
      border-color: #7f4ead !important;

      &::after {
        background-color: #fff !important;
      }
    }
`;
